export function redirect(destination: string) {
  window.location.href = destination;
}

export const currentLocation = window.location.href;
